import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

// Thunk to call the onboarding API
export const startOnboarding = createAsyncThunk(
  "onboarding/startOnboarding",
  async ({ clientId }, { rejectWithValue }) => {
    try {

      const data = await post(`/clients/${clientId}/onboarding`, {})

      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
    clientId: null, // client this onboarding data belongs to; avoid showing wrong client's data
  },
  reducers: {
    clearOnboarding: (state) => {
      state.loading = false
      state.success = false
      state.error = null
      state.data = null
      state.clientId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startOnboarding.pending, (state) => {
        state.loading = true
        state.success = false
        state.error = null
      })
      .addCase(startOnboarding.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.data = action.payload
        state.clientId = action.meta?.arg?.clientId ?? null
      })
      .addCase(startOnboarding.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = action.payload
      })
  },
})

export const { clearOnboarding } = onboardingSlice.actions
export default onboardingSlice.reducer
